<template>
	<div style="min-height: 70vh; max-height: 100%">
		<vx-card
			:title="editable ? $t('MODULE_ROLE.UpdateForm') : $t('MODULE_ROLE.TitleCrear')"
			class="mt-5"
			:cardBorder="true"
			:noShadow="true"
		>
			<vs-row vs-w="12">
				<vs-col vs-lg="12" vs-sm="12" vs-xs="12">
					<div class="vx-row mb-3">
						<div class="vx-col w-full md:w-1/3">
							<vs-input
								:label="$t(`MODULE_ROLE.labelName`)"
								:disabled="editable ? true : false"
								v-model="name"
								class="mt-5 w-full"
								name="name"
								v-validate="'required'"
							/>
							<span class="text-danger text-sm" v-show="errors.has('name')">{{
								$t(`MODULE_ROLE.ValidName`)
							}}</span>
						</div>
						<div class="vx-col w-full md:w-1/3">
							<vs-input
								:label="$t(`MODULE_ROLE.labelAlias`)"
								v-model="alias"
								class="mt-5 w-full"
								name="alias"
								v-validate="'required'"
							/>
							<span class="text-danger text-sm" v-show="errors.has('alias')">{{
								$t(`MODULE_ROLE.ValidAlias`)
							}}</span>
						</div>
						<div class="vx-col w-full md:w-1/3">
							<vs-input
								v-model="description"
								:label="$t(`MODULE_ROLE.labelDescription`)"
								class="mt-5 w-full"
								name="description"
								v-validate="'required'"
							/>
							<span class="text-danger text-sm" v-show="errors.has('description')">{{
								$t(`MODULE_ROLE.ValidDescription`)
							}}</span>
						</div>
					</div>
				</vs-col>
			</vs-row>
		</vx-card>

		<vx-card class="mt-base" no-shadow card-border>
			<div class="vx-row">
				<div class="vx-col w-full">
					<div class="flex items-end px-3">
						<feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
						<span class="font-medium text-lg leading-none">
							{{ $t("MODULE_PERMISSION.Permissions") }}
						</span>
					</div>
					<vs-divider />
				</div>
			</div>

			<div class="block overflow-x-auto">
				<table class="w-full">
					<caption></caption>
					<tr>
						<th
							class="font-semibold text-base text-left px-3 py-2"
							v-for="heading in ['Modules', 'Create', 'Delete', 'Read', 'Update']"
							:key="heading"
						>
							<vs-checkbox
								v-if="heading !== 'Modules'"
								:title="$t('SelectAll')"
								@change="changeCheckAll(heading.charAt(0))"
								>{{ $t(`Crud.${heading}`) }}
							</vs-checkbox>
							<span v-else> {{ $t(`Crud.${heading}`) }} </span>
						</th>
					</tr>
					<tr>
						<td colspan="6">
							<vs-divider />
						</td>
					</tr>

					<tr v-for="name in uniquePermisions" :key="name">
						<td class="px-3 py-2">{{ name }}</td>
						<td v-for="permiso in orderPersmissions(name)" class="px-3 py-2" :key="permiso.permission_name">
							<vs-checkbox
								:title="permiso.description"
								v-model="permiso.check"
								@change="changeCheck(permiso, $event)"
								v-show="!isAdmin(permiso)"
							/>
						</td>
					</tr>
				</table>
			</div>
		</vx-card>
		<div class="vx-row float-right mt-5 mb-5">
			<div class="vx-col w-full">
				<vs-button id="btn-submit-company" class="mr-3 mb-2" :disabled="isFormValid" @click="submitForm">
					{{ editable ? $t("Crud.Update") : $t("Crud.Create") }}
				</vs-button>

				<vs-button
					color="warning"
					type="border"
					class="mb-2"
					@click.stop="editable ? cancelEdit() : $router.push({name: 'role'})"
					>{{ $t("Cancel") }}
				</vs-button>
			</div>
		</div>
	</div>
</template>

<script>
import moduleRole from "@/store/roles/moduleRole.js";

export default {
	props: {
		params: Object,
		editable: Boolean,
	},
	data() {
		return {
			name: this.editable ? this.params.data.name : "",
			alias: this.editable ? this.params.data.alias : "",
			description: this.editable ? this.params.data.description : "",
			// Nombres de los modulos obtenidos de los permisos
			uniquePermisions: [],
			// Listado de todos los permisos del sistema
			permissions: [],
			//Permisos seleccionados
			permissionSelected: [],
			checkAll: false,
			checkAllC: false,
			checkAllR: false,
			checkAllU: false,
			checkAllD: false,
		};
	},
	computed: {
		activeUserInfo() {
			return this.$store.state.AppActiveUser;
		},
		role() {
			return this.params.data;
		},
		listPermissions() {
			return this.$store.state.dataRoles.permissions;
		},
		orderPersmissions() {
			return function (name) {
				function compare(a, b) {
					if (a.letter < b.letter) {
						return -1;
					}
					if (a.letter > b.letter) {
						return 1;
					}
					return 0;
				}

				return this.permissions.filter((r) => r.name === name).sort(compare);
			};
		},
		// Deshabilita o habilita el boton submit a partir de la validez de los campos
		isFormValid() {
			return this.errors.any();
		},
	},
	methods: {
		isAdmin(param) {
			return (
				this.activeUserInfo.serviroutes_role_id == 2 &&
				param &&
				param.name == "ROLE" &&
				(param.letter == "C" || param.letter == "D")
			);
		},
		// Submit al formulario
		submitForm() {
			this.$validator.validateAll().then((result) => {
				// Si el resultado es falso, los campos no son validos
				if (!result) {
					// Valida los campos para poder visualizar los mensaje de error
					this.$validator.validate();
				} else {
					// Los campos del formulario son correctos
					this.correctRole();
				}
			});
		},
		// Rol correcto
		correctRole() {
			// Creacion del objeto
			let objectFinal = {};
			let arrayFinal = this.getCheckedPermissions();
			// Si el formulario tiene permisos seleccionados
			if (arrayFinal.length > 0) {
				// Inserta los id de los permisos seleccionados en el objeto
				objectFinal.permission_id = arrayFinal;
			} else {
				// Sino envia el campo vacio, de lo contrario no actualizara los permisos
				objectFinal.permission_id = [];
			}
			// Se agrega el nombre del Rol al objeto
			objectFinal.name = this.name;
			// Se agrega el nombre del Rol alias al objeto
			objectFinal.alias = this.alias;
			// Se agrega la descripción del Rol al objeto
			objectFinal.description = this.description;
			// Se abre el Load
			this.$vs.loading();
			// Se define si se esta editando el rol o se esta modificando, determinado por el prop this.editable
			if (this.editable) {
				// Actualiza Rol - se envia el objeto construido anteriormente al metodo
				this.updateMethod(objectFinal);
			} else {
				// Crea el Rol - se envia el objeto construido anteriormente al metodo
				this.createMethod(objectFinal);
			}
		},
		// Metodo para crear rol
		createMethod(object) {
			// Llama la accion Vuex, "addRole" y envia el objeto
			this.$store
				.dispatch("dataRoles/addRole", object)
				.then((res) => {
					// Respuesta exitosa
					// Cierra el load
					this.$vs.loading.close();
					// Limpia el formulario
					this.clearForm();
					this.cancelEdit();
					// Muestra mensaje de exito
					this.$vs.notify({
						color: "success",
						title: this.$t("MODULE_ROLE.Hecho"),
						text: this.$t("MODULE_ROLE.msgHecho"),
					});
				})
				.catch((err) => {
					// Respuesta erronea
					// Cierra el load
					this.$vs.loading.close();
					console.error(err);
					// Muestra un mensaje de error
					this.$vs.notify({
						color: "danger",
						title: this.$t("Error"),
						text: this.$t("MODULE_ROLE.ErrorMessages.msgHecho"),
					});
				});
		},
		// Metodo que actualiza el rol
		updateMethod(object) {
			// inserta el id en el objeto para utilizarlo en la url del PUT
			object.id = this.role.id;
			// Llama la acción Vuex "updateRole" y envia el objeto
			this.$store
				.dispatch("dataRoles/updateRole", object)
				.then((res) => {
					// Respuesta exitosa
					// cierra el load
					this.$vs.loading.close();
					// limpia el formulario
					this.clearForm();
					// Cancela la edición
					this.cancelEdit();
					// Muestra mensaje de exito
					this.$vs.notify({
						color: "success",
						title: this.$t("MODULE_ROLE.Change"),
						text: this.$t("MODULE_ROLE.msgChange"),
					});
				})
				.catch((err) => {
					// Respuesta errornea
					// Cierra lod
					this.$vs.loading.close();
					console.error(err);
					// Muestra mensaje de error
					this.$vs.notify({
						color: "danger",
						title: this.$t("Error"),
						text: this.$t("MODULE_ROLE.ErrorMessages.msgChange"),
					});
				});
		},
		// Cancela edición en curso
		cancelEdit() {
			// Limpia el formulario
			this.clearForm();
			this.$router.push({name: "role"});
		},
		clearForm() {
			this.permissionSelected = [];
			this.$validator.reset();
		},
		// Metodo para renombrar propiedades de un objeto (Se utiliza más adelante)
		renameProperty(obj, oldName, newName) {
			obj[newName] = obj[oldName];
			delete obj[oldName];
			//obj[newName] = ''
			return obj;
		},
		changeCheckAll(permiso) {
			switch (permiso) {
				case "C":
					this.changeCheckAllC();
					break;
				case "R":
					this.changeCheckAllR();
					break;
				case "U":
					this.changeCheckAllU();
					break;
				case "D":
					this.changeCheckAllD();
					break;
				default:
					break;
			}
		},
		changeCheckAllC() {
			this.checkAllC = !this.checkAllC;
			const filter = this.permissions.filter(({letter}) => letter === "C");
			filter.forEach((per) => {
				const perIndex = this.permissions.findIndex((p) => p.id === per.id);
				Object.assign(this.permissions[perIndex], {
					check: this.checkAllC,
				});
			});
		},
		changeCheckAllR() {
			this.checkAllR = !this.checkAllR;
			const filter = this.permissions.filter(({letter}) => letter === "R");
			filter.forEach((per) => {
				const perIndex = this.permissions.findIndex((p) => p.id === per.id);
				Object.assign(this.permissions[perIndex], {
					check: this.checkAllR,
				});
			});
		},
		changeCheckAllU() {
			this.checkAllU = !this.checkAllU;
			const filter = this.permissions.filter(({letter}) => letter === "U");
			filter.forEach((per) => {
				const perIndex = this.permissions.findIndex((p) => p.id === per.id);
				Object.assign(this.permissions[perIndex], {
					check: this.checkAllU,
				});
			});
		},
		changeCheckAllD() {
			this.checkAllD = !this.checkAllD;
			const filter = this.permissions.filter(({letter}) => letter === "D");
			filter.forEach((per) => {
				const perIndex = this.permissions.findIndex((p) => p.id === per.id);
				Object.assign(this.permissions[perIndex], {
					check: this.checkAllD,
				});
			});
		},
		getCheckedPermissions() {
			const checkedPer = this.permissions.filter((p) => p.check).map((p) => p.id);
			return checkedPer;
		},
		changeCheck(e, val) {},
		formatPermissions() {
			this.listPermissions.forEach((element) => {
				let splitName = element.name.split("_");
				let name = splitName.length === 3 ? `${splitName[0]}_${splitName[1]}` : splitName[0];
				let letter = splitName.length === 3 ? splitName[2] : splitName[1];
				let id = element.id;
				let permission_name = element.name;
				let description = element.description;
				let check = false;
				this.permissions.push({
					name,
					permission_name,
					letter,
					id,
					check,
					description,
				});
			});

			this.uniquePermisions = [...new Set(this.permissions.map(({name}) => name))];
			if (this.editable) {
				this.setCheckPermissions();
			}
		},
		setCheckPermissions() {
			this.permissionSelected.forEach((permissionSelected) => {
				const perIndex = this.permissions.findIndex((p) => p.id === permissionSelected.id);
				Object.assign(this.permissions[perIndex], {check: true});
			});
		},
		consultPermissions() {
			// Abre el load
			this.$vs.loading();
			// Actualiza los permisos los permisos
			this.$store
				.dispatch("dataRoles/getPermissions")
				.then((res) => {
					// Respuesta exitosa
					// Cierra el load
					this.$vs.loading.close();
					this.formatPermissions();
				})
				.catch((err) => {
					// Respuesta erronea
					// cierra el load
					this.$vs.loading.close();
					// Muestra mensaje de error
					this.$vs.notify({
						color: "danger",
						title: this.$t("Error"),
						text: this.$t("MODULE_ROLE.ErrorMessages.ConsultPermission"),
					});
					console.error(err);
					this.cancelEdit();
				});
		},
	},
	created() {
		if (!moduleRole.isRegistered) {
			this.$store.registerModule("dataRoles", moduleRole);
			moduleRole.isRegistered = true;
		}
		this.consultPermissions();

		if (this.editable) {
			let cont = 0;
			Object.keys(this.params.data.permissions).forEach((key) => {
				this.renameProperty(this.params.data.permissions[cont], "permission_name", "name");
				this.renameProperty(this.params.data.permissions[cont], "permission_id", "id");
				cont++;
			});

			// Al tener el arreglo de permisos seleccionados se le asigna al options del multi-select, el cual selecciona los permisos
			this.permissionSelected = this.params.data.permissions;
		}
	},
};
</script>
